/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import Styles from './author-tag.less';

export interface IHistoryAuthorTagProps {
    key: number;
    visible: boolean;
    authorName: string;
    color: any;
    zIndex: number;
    x?: number;
    y: number;
}

export default class HistoryAuthorTag extends React.Component<Partial<IHistoryAuthorTagProps>, any> {
    public state = {
        animating: false,
    };

    public prevVisible = false;

    public get displaying() {
        return this.state.animating || this.props.visible;
    }

    public componentDidUpdate(nextProps) {
        if (this.props.visible !== nextProps.visible) {
            this.setState({ animating: true });
        }
    }

    public handleAnimationEnd = () => {
        this.setState({ animating: false });
    };

    public render() {
        if (this.prevVisible !== this.props.visible) {
            this.prevVisible = !!this.props.visible;
        }
        return (
            <React.Fragment>
                {this.displaying ? <div
                    className={classNames({
                        [Styles['author-tag']]: true,
                        [Styles['fade-in']]: this.props.visible,
                        [Styles['fade-out']]: !this.props.visible,
                    })}
                    style={{
                        backgroundColor: this.props.color || 'black',
                        zIndex: this.props.zIndex || 'auto',
                        transform: `translate(${this.props.x || 0}px, ${this.props.y || 0}px)`,
                    }}
                    onAnimationEnd={this.handleAnimationEnd}
                >
                    {this.props.authorName}
                </div> : null}
            </React.Fragment>
        );
    }
}
